import { PatchNotes } from "../../types/patches";

export const patch: PatchNotes = {
  id: "patch-5.0.9369",
  buildId: "5.0.9369",
  name: "Patch 9369",
  season: 0,
  type: "patch",
  officialUrl: "https://www.ageofempires.com/news/aoe-iv-patch-9369",
  summary: "",
  introduction: `
![](https://www.ageofempires.com/wp-content/uploads/2021/12/PatchNote_MON_1920x1080-1080x608.jpg)
""`,
  date: new Date("2021-12-06T18:44:59Z"),
  sections: [

  ],
};
